import { render } from "./VsTabs.vue?vue&type=template&id=10e36fba"
import script from "./VsTabs.vue?vue&type=script&lang=js"
export * from "./VsTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__